"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import { usePathname, useSearchParams } from "next/navigation";
import { useSession } from "next-auth/react";
import { useEffect, useRef, useState, useCallback } from "react";
import { gtmEvent, GTM_EVENTS } from "@/utils/gtm-helpers";
import { Session } from "@/types/session";
interface GTMProps {
  gtmID: string;
}
export default function GTM(t0) {
  const $ = _c(18);
  const {
    gtmID
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    data: sessionData,
    status
  } = useSession();
  const session = sessionData as Session;
  const [isLoaded, setIsLoaded] = useState(false);
  const lastPageView = useRef("");
  const previousUrl = useRef("");
  let t1;
  if ($[0] !== pathname || $[1] !== searchParams || $[2] !== session?.user?.email || $[3] !== session?.user?.id) {
    t1 = () => {
      const sessionId = sessionStorage.getItem("x-session-id") || "";
      const referrer = previousUrl.current || document.referrer || "";
      const pageKey = [pathname, searchParams?.toString(), sessionId, session?.user?.id].join("|");
      if (pageKey === lastPageView.current) {
        return;
      }
      gtmEvent(GTM_EVENTS.PAGE_VIEW, document, sessionId, session?.user?.id ?? "", session?.user?.email ?? "", referrer);
      lastPageView.current = pageKey;
      previousUrl.current = window.location.href;
    };
    $[0] = pathname;
    $[1] = searchParams;
    $[2] = session?.user?.email;
    $[3] = session?.user?.id;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const triggerPageView = t1;
  let t2;
  if ($[5] !== isLoaded || $[6] !== status || $[7] !== triggerPageView) {
    t2 = () => {
      if (status === "loading" || !isLoaded) {
        return;
      }
      triggerPageView();
    };
    $[5] = isLoaded;
    $[6] = status;
    $[7] = triggerPageView;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== isLoaded || $[10] !== pathname || $[11] !== searchParams || $[12] !== status || $[13] !== triggerPageView) {
    t3 = [pathname, searchParams, status, isLoaded, triggerPageView];
    $[9] = isLoaded;
    $[10] = pathname;
    $[11] = searchParams;
    $[12] = status;
    $[13] = triggerPageView;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  useEffect(t2, t3);
  let t4;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsLoaded(true);
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const t5 = `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtmID}');
        `;
  let t6;
  if ($[16] !== t5) {
    t6 = <Script id="google-tag-manager" strategy="afterInteractive" onReady={t4} dangerouslySetInnerHTML={{
      __html: t5
    }} />;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}